var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpenditureClearance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2209 1.33594H1.77648C1.53102 1.33594 1.33203 1.53492 1.33203 1.78038V3.26186C1.33203 3.50732 1.53102 3.70631 1.77648 3.70631H14.2209C14.4664 3.70631 14.6654 3.50732 14.6654 3.26186V1.78038C14.6654 1.53492 14.4664 1.33594 14.2209 1.33594Z",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7782 3.70312H2.22266V11.555H13.7782V3.70312Z",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0732V11.5547",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 11.5547H14.6654",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77734 6.375H11.5551",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77734 8.44531H11.5551",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92622 9.18837C6.90806 9.18837 7.70399 8.39243 7.70399 7.41059C7.70399 6.42875 6.90806 5.63281 5.92622 5.63281C4.94438 5.63281 4.14844 6.42875 4.14844 7.41059C4.14844 8.39243 4.94438 9.18837 5.92622 9.18837Z",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88715 14.6707C8.88715 14.3448 8.49012 14.0781 7.99826 14.0781C7.50641 14.0781 7.10938 14.3448 7.10938 14.6707",
    stroke: "#F1F2F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenditureClearance);
export default __webpack_public_path__ + "static/media/expenditureClearance.1c49729c809ce33c6453724dc74bde54.svg";
export { ForwardRef as ReactComponent };